// Mutations
// `items = []` por padrão: uma resposta 200 sem a chave `items` fazia o
// spread estourar com "items is not iterable" e derrubar a tela. Os getters e
// as demais mutations já normalizam nulo; esta era a única porta aberta.
export const SET_ARTICLES = (state, { items = [], next_cursor: nextCursor, has_more: hasMore, append }) => {
  state.articles = {
    ...state.articles,
    // `append` distingue scroll infinito (acrescenta) de troca de filtro
    // (substitui). Sem isso, filtrar mostraria o resultado novo grudado no
    // antigo.
    data: append ? [...state.articles.data, ...items] : items,
    nextCursor: nextCursor || null,
    hasMore: !!hasMore,
    error: false,
    lastUpdate: new Date(),
  }
}

export const SET_ARTICLES_ERROR = (state) => {
  state.articles = { ...state.articles, error: true, hasMore: false }
}

export const SET_LOADING = (state, payload) => {
  state.articles = { ...state.articles, loading: payload }
}

export const SET_SOURCES = (state, payload) => {
  state.sources = payload || []
}

export const SET_FILTRO_SOURCES = (state, payload) => {
  state.filtros = { ...state.filtros, sources: payload || [] }
}

export const SET_FILTRO_TERMO = (state, payload) => {
  state.filtros = { ...state.filtros, termo: payload || '' }
}

export const RESET_ARTICLES = (state) => {
  state.articles = {
    ...state.articles,
    data: [],
    nextCursor: null,
    hasMore: false,
    error: false,
  }
}
